import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import {BrowserRouter,ScrollRestoration} from "react-router-dom";
import {addToast, HeroUIProvider} from "@heroui/react";
import axios from "axios";

import {ThemeProvider as NextThemesProvider} from "next-themes";
import ErrorBoundary from "./components/ErrorBoundry";
import {pb} from "./proto/action";


window.debug = true

//https://github.com/heroui-inc/heroui/discussions/2080?sort=top#discussioncomment-9207779
/*
const originalWarn = console.warn
console.warn = (...args) => {
    const [firstArg] = args;
    if (
        typeof firstArg === "string" &&
        firstArg.includes(
            "An aria-label or aria-labelledby prop is required for accessibility."
        )
    ) {
        return;
    }

    originalWarn(...args);
};

 */
if (import.meta.env?.DEV) {
    const script = document.createElement('script');
    script.src = '//unpkg.com/react-scan/dist/auto.global.js';
    script.crossOrigin = 'anonymous';
    document.head.prepend(script);
}
if (typeof crypto !== 'undefined' && typeof crypto.randomUUID !== 'function') {
    crypto.randomUUID = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
}
window.formatNumber = (num) => {
    if (num === null || num === undefined || isNaN(num) || Number(num) === 0) return '0';

    const n = Number(num);
    const abs = Math.abs(n);
    const units = ['', 'K', 'M', 'G', 'T', 'P'];
    const tier = Math.floor(Math.log10(abs) / 3);
    const safeTier = Math.min(Math.max(tier, 0), units.length - 1);
    const unit = units[safeTier];
    const scaled = n / Math.pow(10, safeTier * 3);

    // toFixed(1) 保留一位小数，parseFloat 会自动省略末尾的 .0
    const formattedNum = parseFloat(scaled.toFixed(1));

    return formattedNum + unit;
};
window.vhToPx = (vhPercent) =>{
    const vh = window.innerHeight;
    return (vhPercent / 100) * vh;
}

window.vwToPx= (vhPercent) =>{
    const vh = window.innerWidth;
    return (vhPercent / 100) * vh;
}
window.formatFloat = (str) =>{
    if (typeof str !== 'string') {
        str = str + ''
    }
    const num = Number(str);
    if (Number.isNaN(num)) return str;
    return String(Number(num.toFixed(1)));
}
window.timestampToDate = (ts) => {
    if (!ts) return null;
    if (typeof ts === 'string') {
        return new Date(ts)
    }
    const seconds = Number(ts.seconds || 0);
    const nanos = Number(ts.nanos || 0);
    return new Date(seconds * 1000 + Math.floor(nanos / 1e6));
}
window.AVATAR_API = 'https://workers.vrp.moe/bilibili/avatar/'
document.title = "Vtuber 数据"
axios.interceptors.request.use((config) => {
    if (import.meta.env.PROD) {
        config.url = config.url?.replace('/api/', '/')
        if (config.url.startsWith('/')) {
            config.url = 'https://api.vtb.cat' + config.url;
        }
        var url = new URL(config.url);
        url.host = 'api.vtb.cat'
        if (!url.toString().includes('comment') && !url.toString().includes('.md')) {
            if (location.hostname === 'vtb.cat') {
                //url.host = 'stuff.vtb.cat'
            }
        }

        config.url = url.toString()
    }
    if (config.url.includes('pb=1')) {
        config.responseType = "arraybuffer";
    }
    //config.headers["X-Session"] = localStorage.getItem("session_v2");
    return config;
});
axios.interceptors.response.use(
    (response) => {
        const contentType = response.headers["content-type"] || "";
        const protoType = response.headers["x-protobuf-schema"];


        const isProtoResponse =
            contentType.includes("application/x-protobuf")

        if (isProtoResponse && protoType) {
            try {

                const uint8Array = new Uint8Array(response.data);

                const MessageClass =
                    typeof protoType === "string" ? pb[protoType] : protoType;

                if (!MessageClass || !MessageClass.decode) {
                    throw new Error(`找不到对应的 Proto 类: ${protoType}`);
                }
                const decodedMessage = MessageClass.decode(uint8Array);

                response.data = MessageClass.toObject(decodedMessage, {
                    longs: String,
                    enums: String,
                    defaults: true,
                    arrays: true,
                    objects: true,
                    keepCase: true,
                });
            } catch (err) {
                console.error("Protobuf 反序列化失败:", err);
                return Promise.reject(err);
            }
        }

        return response;
    },
    (error) => {

        return Promise.reject(error);
    }
);
window.GIFT_MAP = new Map()

window.toSpace = UID => {
    window.open('https://space.bilibili.com/' + UID, '_blank');
}
window.host = location.hostname;

window.port = location.port;

window.CACHED_FILES = new Map()

window.protocol = location.protocol.replace(":","")
document.addEventListener("DOMContentLoaded", (event) => {
    window.page = 1
});
window.getGuardIcon= (level) =>{
    var array = ["","https://i1.hdslb.com/bfs/static/blive/blfe-live-room/static/img/logo-1.b718085..png","https://i1.hdslb.com/bfs/static/blive/blfe-live-room/static/img/logo-2.d43d078..png","https://i1.hdslb.com/bfs/static/blive/blfe-live-room/static/img/logo-3.6d2f428..png"]
    return array[level]
}
window.getColor = (level) => {
    if (level <= 10) return "#727BB5";
    if (level <= 20) return "#CF86B2";
    if (level <= 30) return "#5EC0F7";
    if (level <= 40) return "#6992FF";
    if (level <= 50) return "#AA78F1";
    if (level <= 60) return "#ED5674";
    if (level <= 70) return "#F58737";
    if (level <= 80) return "#F58837";
    if (level <= 90) return "#F58837";
    return "#FF9D55";
}
window.isMobile = () => {
    const uaMatch = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    return uaMatch || window.innerWidth <= 768;
};
window.isDesktop = () => {
    return !window.isMobile();
};
window.getOpacity = ()=> {
    var op = localStorage.getItem("opacity")
    if (op === null) {
        localStorage.setItem("opacity","100")
        return 100
    } else {
        return op
    }
}

window.inspectGuard = (obj) => {

    //返回true表示是刷的舰长

    if (obj.MessageCount > 20) return false

    if (obj.MessageCount === 0 && obj.GuardCount === 0 && obj.Level > 21) {
        return false
    }

    if (obj.Level > 24) {
        return false
    }

    if (obj.OverEnter === true) {
        return false
    }

    if (obj.MessageCount === 0) {
        return true
    }

    if (obj.TimeOut === false) {
        return true
    }

    if (obj.GuardCount / (obj.MessageCount + obj.GuardCount) > 0.5) {
        return true
    }

    return false

}
const fetchGuild = async (force) => {
    if (!localStorage.getItem("guild") || force) {
        const response = await fetch('https://storage.vtb.cat/d/R2/bili_guild_infos.json',{
            referrerPolicy: "no-referrer"
        });
        const arrayBuffer = await response.arrayBuffer()
        var dec = new TextDecoder();
        localStorage.setItem("guild", dec.decode(arrayBuffer).substring(0));
    }
}
window.fetchGuild = fetchGuild
axios.interceptors.request.use(function (config) {
    if (typeof config.url === "string") {
        config.url = config.url.replaceAll('%20','').replaceAll(' ','') //UserPage的room不知道为啥，第一次请求的时候room会是一个空格而不是空字符串，先这样吧
    }

    return config;
  }, function (error) {
    return Promise.reject(error);
  });
window.SEARCH_LIVER = ""
fetchGuild();
var html = document.querySelector('html')
var item = localStorage.getItem("background")
if (item != null) {
    html.style.backgroundImage = `url("${item}")`
    html.style.backgroundSize = 'cover'
    html.style.backgroundAttachment = 'fixed'
    html.style.backgroundPosition = 'center'
}
if (!window.config) {
    window.config = {
        COMMENT_OWNER:[
            '8D7765',
            '742C37'
        ]
    }
}
var session = localStorage.getItem("session")
if (session === null || session === undefined || session === '') {


    //localStorage.setItem("session", UUID())

}

/*var v2 = localStorage.getItem("session_v2")
if (!v2) {
    var value = UUID()
    localStorage.setItem("session_v2", value)
    axios.post("/api/auth/create?uuid=" + value)
}*/

if (localStorage.getItem("defaultPageSize") === null) {
    localStorage.setItem("defaultPageSize", "100");
}
if (localStorage.getItem('flag_page_size_500') === null) {
    localStorage.setItem('flag_page_size_500', 'true')
    localStorage.setItem("defaultPageSize", "500");
}

window.getSystemTheme = () =>{
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}
window.PRELOAD_AD =''
axios.get('/api/ad').then((response) => {
    window.PRELOAD_AD = response.data;
})
axios.create().get(
    'https://fetch.danmakus.com/https://workers.vrp.moe/bilibili/room-gift-config/25034104?list=1').then((response) => {
        response.data.data.list.forEach((item) => {
            GIFT_MAP.set(item.name, item.webp)
        })
})

createRoot(document.getElementById('root')).render(
      <HeroUIProvider locale={typeof navigator !== "undefined" ? navigator.language : "zh-CN"}>

              <BrowserRouter>
                  <NextThemesProvider attribute="class" defaultTheme={getSystemTheme()}>
                      <ErrorBoundary>
                          <App/>

                      </ErrorBoundary>


                  </NextThemesProvider>
              </BrowserRouter>


      </HeroUIProvider>
)
